// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ─── Page Layout ─────────────────────────────────────────────────────────── */
.user-access-page {
  min-height: 125vh;
  zoom: 0.8;
}

/* Top logo / title bar */
.user-access-page__header {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px 32px;
}

.user-access-page__logo-bar {
  display: flex;
  align-items: center;
  gap: 16px;
}

.user-access-page__logo {
  height: 1.5rem;
  width: auto;
}

/* Scrollable main content area */
.user-access-page__content {
  padding: 32px;
  max-width: 1600px;
  margin: 0 auto;
}

/* ─── Paper / Card Container ──────────────────────────────────────────────── */
.user-access-paper {
  padding: 24px;
  border: 1px solid #e0e0e0;
}

/* ─── Alert messages ──────────────────────────────────────────────────────── */
.user-access-alert {
  margin-bottom: 16px;
}

/* ─── Table section header row (title + action buttons) ──────────────────── */
.user-access-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.user-access-header__actions {
  display: flex;
  gap: 16px;
}

/* ─── Action Buttons (Add / Export / Back) ────────────────────────────────── */
.user-access-action-btn {
  background-color: #ffbc0d;
  color: #000000;
  font-weight: 700;
  font-size: 12px;
  padding: 8px 16px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 38px;
  transition: background-color 0.2s ease, opacity 0.2s ease;
  text-transform: none;
  font-family: inherit;
}

.user-access-action-btn:hover:not(:disabled) {
  background-color: #e5a80c;
}

.user-access-action-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  background-color: #ffbc0d;
}

/* ─── Search Bar ──────────────────────────────────────────────────────────── */
.user-access-search-bar {
  display: flex;
  gap: 16px;
  align-items: flex-end;
  margin-bottom: 24px;
}

.user-access-search-bar__input {
  min-width: 300px;
}

.user-access-search-bar__reset-btn {
  margin-bottom: 4px;
}

/* ─── Loading Spinner ─────────────────────────────────────────────────────── */
.user-access-loader {
  display: flex;
  justify-content: center;
  padding: 64px;
}

/* ─── Table Sort Label Icon Opacity ───────────────────────────────────────── */
.user-access-sort-label .MuiTableSortLabel-icon {
  opacity: 0.5;
}

.user-access-sort-label.Mui-active .MuiTableSortLabel-icon {
  opacity: 1;
}

/* ─── Status Column fixed width ───────────────────────────────────────────── */
.user-access-status-col {
  width: 150px;
}
`, "",{"version":3,"sources":["webpack://./src/components/UserAccess/UserAccess.css"],"names":[],"mappings":"AAAA,gFAAgF;AAChF;EACE,iBAAiB;EACjB,SAAS;AACX;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA,gFAAgF;AAChF;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA,gFAAgF;AAChF;EACE,mBAAmB;AACrB;;AAEA,+EAA+E;AAC/E;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA,gFAAgF;AAChF;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,yDAAyD;EACzD,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,gFAAgF;AAChF;EACE,aAAa;EACb,SAAS;EACT,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,gFAAgF;AAChF;EACE,aAAa;EACb,uBAAuB;EACvB,aAAa;AACf;;AAEA,gFAAgF;AAChF;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA,gFAAgF;AAChF;EACE,YAAY;AACd","sourcesContent":["/* ─── Page Layout ─────────────────────────────────────────────────────────── */\n.user-access-page {\n  min-height: 125vh;\n  zoom: 0.8;\n}\n\n/* Top logo / title bar */\n.user-access-page__header {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 16px 32px;\n}\n\n.user-access-page__logo-bar {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.user-access-page__logo {\n  height: 1.5rem;\n  width: auto;\n}\n\n/* Scrollable main content area */\n.user-access-page__content {\n  padding: 32px;\n  max-width: 1600px;\n  margin: 0 auto;\n}\n\n/* ─── Paper / Card Container ──────────────────────────────────────────────── */\n.user-access-paper {\n  padding: 24px;\n  border: 1px solid #e0e0e0;\n}\n\n/* ─── Alert messages ──────────────────────────────────────────────────────── */\n.user-access-alert {\n  margin-bottom: 16px;\n}\n\n/* ─── Table section header row (title + action buttons) ──────────────────── */\n.user-access-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n}\n\n.user-access-header__actions {\n  display: flex;\n  gap: 16px;\n}\n\n/* ─── Action Buttons (Add / Export / Back) ────────────────────────────────── */\n.user-access-action-btn {\n  background-color: #ffbc0d;\n  color: #000000;\n  font-weight: 700;\n  font-size: 12px;\n  padding: 8px 16px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  height: 38px;\n  transition: background-color 0.2s ease, opacity 0.2s ease;\n  text-transform: none;\n  font-family: inherit;\n}\n\n.user-access-action-btn:hover:not(:disabled) {\n  background-color: #e5a80c;\n}\n\n.user-access-action-btn:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n  background-color: #ffbc0d;\n}\n\n/* ─── Search Bar ──────────────────────────────────────────────────────────── */\n.user-access-search-bar {\n  display: flex;\n  gap: 16px;\n  align-items: flex-end;\n  margin-bottom: 24px;\n}\n\n.user-access-search-bar__input {\n  min-width: 300px;\n}\n\n.user-access-search-bar__reset-btn {\n  margin-bottom: 4px;\n}\n\n/* ─── Loading Spinner ─────────────────────────────────────────────────────── */\n.user-access-loader {\n  display: flex;\n  justify-content: center;\n  padding: 64px;\n}\n\n/* ─── Table Sort Label Icon Opacity ───────────────────────────────────────── */\n.user-access-sort-label .MuiTableSortLabel-icon {\n  opacity: 0.5;\n}\n\n.user-access-sort-label.Mui-active .MuiTableSortLabel-icon {\n  opacity: 1;\n}\n\n/* ─── Status Column fixed width ───────────────────────────────────────────── */\n.user-access-status-col {\n  width: 150px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
